import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminNotification } from "../../services/adminNotification.service.ts";

type AdminNotificationsState = {
  items: AdminNotification[];
  unreadCount: number;
  loading: boolean;
  total: number;
  limit: number;
  offset: number;
};

const initialState: AdminNotificationsState = {
  items: [],
  unreadCount: 0,
  loading: false,
  total: 0,
  limit: 20,
  offset: 0,
};

const adminNotificationsSlice = createSlice({
  name: "adminNotifications",
  initialState,
  reducers: {
    setAdminNotificationsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAdminNotificationsPage: (
      state,
      action: PayloadAction<{
        items: AdminNotification[];
        total: number;
        unreadCount: number;
        offset?: number;
        limit?: number;
      }>
    ) => {
      state.items = action.payload.items;
      state.total = action.payload.total;
      state.unreadCount = action.payload.unreadCount;
      if (typeof action.payload.offset === "number") {
        state.offset = action.payload.offset;
      }
      if (typeof action.payload.limit === "number") {
        state.limit = action.payload.limit;
      }
    },
    setAdminUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = Math.max(0, Number(action.payload) || 0);
    },
    markAdminNotificationReadLocal: (state, action: PayloadAction<number>) => {
      const item = state.items.find((n) => n.id === action.payload);
      if (item) {
        if (!item.isRead) {
          item.isRead = true;
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
        return;
      }
      // Marcada desde dropdown (items locales): aún así bajar el badge.
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },
    markAllAdminNotificationsReadLocal: (state) => {
      state.items = state.items.map((item) => ({ ...item, isRead: true }));
      state.unreadCount = 0;
    },
    setAdminNotificationsOffset: (state, action: PayloadAction<number>) => {
      state.offset = action.payload;
    },
    resetAdminNotifications: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setAdminNotificationsLoading,
  setAdminNotificationsPage,
  setAdminUnreadCount,
  markAdminNotificationReadLocal,
  markAllAdminNotificationsReadLocal,
  setAdminNotificationsOffset,
  resetAdminNotifications,
} = adminNotificationsSlice.actions;

export default adminNotificationsSlice.reducer;
